import { render, staticRenderFns } from "./AdresseLivraison.vue?vue&type=template&id=36b9a24e&scoped=true&lang=html"
import script from "./AdresseLivraison.vue?vue&type=script&lang=js"
export * from "./AdresseLivraison.vue?vue&type=script&lang=js"
import style0 from "./AdresseLivraison.vue?vue&type=style&index=0&id=36b9a24e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b9a24e",
  null
  
)

export default component.exports